import React, { useEffect } from "react";
import styled from "styled-components";

const Toast = ({ show, message, fontColor, bgColor, delay, callback }) => {
  if (!delay || delay === 0) {
    // ms
    delay = 3000;
  }

  useEffect(() => {
    if (show === true) {
      setTimeout(() => {
        if (callback && typeof callback === "function") {
          callback(false);
        }
      }, delay);
    }
  }, [show, callback, delay]);

  return (
    <StyledToast className={show === true ? "show" : ""} fontColor={fontColor} bgColor={bgColor} delay={delay}>
      {message}
    </StyledToast>
  );
};

export default Toast;

const StyledToast = styled.div.attrs((props) => ({
  fontColor: props.fontColor || "#fff",
  bgColor: props.bgColor || "#333",
  delay: `${(props.delay - 400) / 1000}s` || "2.5s",
}))`
  visibility: hidden;
  min-width: 250px;
  max-width: 350px;
  margin: 0px auto;
  color: ${(props) => props.fontColor};
  background-color: ${(props) => props.bgColor};
  text-align: center;
  border-radius: 4px;
  padding: 10px;
  position: fixed;
  z-index: 1001;
  left: 0;
  right: 0;
  bottom: 30px;
  font-size: 14px;
  box-sizing: border-box;

  &.show {
    visibility: visible;
    -webkit-animation: fadein 0.5s, fadeout 0.5s ${(props) => props.delay};
    animation: fadein 0.5s, fadeout 0.5s ${(props) => props.delay};
  }

  @-webkit-keyframes fadein {
    from {
      bottom: 0;
      opacity: 0;
    }
    to {
      bottom: 30px;
      opacity: 1;
    }
  }

  @keyframes fadein {
    from {
      bottom: 0;
      opacity: 0;
    }
    to {
      bottom: 30px;
      opacity: 1;
    }
  }

  @-webkit-keyframes fadeout {
    from {
      bottom: 30px;
      opacity: 1;
    }
    to {
      bottom: 0;
      opacity: 0;
    }
  }

  @keyframes fadeout {
    from {
      bottom: 30px;
      opacity: 1;
    }
    to {
      bottom: 0;
      opacity: 0;
    }
  }

  @media screen and (max-width: 834px) {
    max-width: 300px;
  }
`;
